import FONDO from "../assets/ONEE.jpg";

const SectionOne = () => {
  return (
    <div
      className="relative w-full h-[75vh] overflow-hidden bg-cover bg-top flex justify-center items-center"
      style={{ backgroundImage: `url(${FONDO})` }}
    >
      <div className="w-full h-full flex flex-col justify-center items-center p-4 md:p-16 text-white z-40">
        <h2 className="md:text-3xl font-light">Grupo de Autores Aplicados</h2>
        <h1 className="text-2xl md:text-6xl font-bold">Protégete del plagio</h1>
      </div>
      <div className="absolute inset-0 bg-slate-700/75 z-20" />
      <div className="absolute -bottom-1 left-0 w-full overflow-hidden leading-none z-40">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 1440 155"
          preserveAspectRatio="none"
          className="w-full h-[120px] md:h-[155px]"
        >
          <path
            d="M0,94.716964 C390.59867,-15.901776 919.556541,-47.810391 1440,92.653343 C1440,102.563675 1440,133.065337 1440,154 C1422.97118,154 942.971175,154 0,154 C0,119.483952 0,99.389606 0,94.716964 Z"
            fill="#FFFFFF"
          />
        </svg>
      </div>
    </div>
  );
};

export default SectionOne;
